<template>
  <div class="journey-step px-5 py-2">
    <div class="d-flex flex-row align-center">
      <div class="flex-grow-1" v-html="getStepHTML(getJourney[stepIndex].name[defaultLanguage] || getJourney[stepIndex].name[defaultLanguage] || $t('journeystep_edit_me'))">
      </div>
      <div>
        <v-btn @click="openStepEdit" small icon>
          <v-icon color="accent">mdi-cog-outline</v-icon>
        </v-btn>
        <v-btn @click="deleteStep" small class="ma-0" icon>
          <v-icon>$remove</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="d-flex flex-row align-center">
      <div class="flex-grow-1">
        <v-icon>mdi-map-marker</v-icon>
        <span v-html="getStepHTML(getJourney[stepIndex].location[defaultLanguage] || $t('journeystep_step_location'))"></span>
      </div>
      <div>
        <div v-html="getStepHTML(getJourney[stepIndex].date || $t('journeystep_step_date'))"></div>
      </div>
    </div>

    <v-dialog content-class="edit-dialog" width="800" persistent v-model="editModal">
      <v-card>
        <v-card-title class="headline">{{$t('journeystep_configure_step')}}</v-card-title>
        <v-card-text>
            <div class="font-weight-light pb-5" v-html="$t('journeystep_select_scm_field')"></div>
            <rich-text-input :label="$t('journeystep_step_description')" mode="input" :content.sync="stepData.name[defaultLanguage]" :json.sync="jsonObj.name" :placeholder="$t('journeystep_enter_description')">
            </rich-text-input>
            <v-row no-gutter class="mt-4">
              <v-col cols="6">
                <rich-text-input :label="$t('journeystep_step_location_label')" mode="input" :content.sync="stepData.location[defaultLanguage]" :json.sync="jsonObj.location" :placeholder="$t('journeystep_enter_location')">
                </rich-text-input>
              </v-col>
              <v-col cols="6">
                <rich-text-input :label="$t('journeystep_select_date')" mode="input" :content.sync="stepData.date" :json.sync="jsonObj.date" :placeholder="$t('journeystep_enter_date')">
                </rich-text-input>
              </v-col>
            </v-row>
            <v-row class="d-flex flex-row mt-4">
              <v-col cols="6">
                <rich-text-input :label="$t('journeystep_step_latitude')" mode="input" :content.sync="stepData.lat" :json.sync="jsonObj.lat" :placeholder="$t('journeystep_enter_latitude')">
                </rich-text-input>
              </v-col>
              <v-col cols="6">
                <rich-text-input :label="$t('journeystep_step_longitude')" mode="input" :content.sync="stepData.lng" :json.sync="jsonObj.lng" :placeholder="$t('journeystep_enter_longitude')">
                </rich-text-input>
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{$t('close')}}</v-btn>
          <v-btn text @click="save" color="primary">{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import RichTextInput from '@/components/utils/RichTextInput'

export default {
  name: 'journey-step',
  props: ['stepIndex', 'step'],
  computed: {
    ...mapGetters(['findDynamicVariable', 'getJourney', 'defaultLanguage'])
  },
  components: {
    'rich-text-input': RichTextInput
  },
  methods: {

    getStepHTML (string) {
      const matches = string.match(/\{(.*?)\}/)

      if (matches) {
        const submatch = matches[1]
        const before = string.substr(0, string.indexOf('{'))
        const after = string.substr(string.indexOf('}') + 1)

        return `${before}<span class="scm-field">{${submatch}}</span>${after}`
      } else {
        return string
      }
    },

    convertToMention (string) {
      const matches = string.match(/\{(.*?)\}/)

      if (matches) {
        const submatch = matches[1]
        const before = string.substr(0, string.indexOf('{'))
        const after = string.substr(string.indexOf('}') + 1)

        return `${before}<span data-mention-id="${this.findDynamicVariable(submatch).key}">@${submatch}</span>${after}`
      } else {
        return string
      }
    },

    convertToSTCString (json) {
      let string = ''

      if (json.content) {
        json.content.forEach((elem) => {
          if (elem.type === 'text') {
            string += elem.text
          } else if (elem.type === 'mention') {
            string += `{${elem.attrs.id}}`
          }
        })
      }

      return string
    },

    openStepEdit () {
      this.editModal = true
    },

    deleteStep () {
      this.$store.dispatch('deleteJourneyStep', { index: this.stepIndex })
    },

    save () {
      // Hack to blur combo box and force an object update
      // this.$refs['lng-combobox'].blur()
      // this.$refs['lat-combobox'].blur()
      // this.$refs['location-combobox'].blur()
      // this.$refs['date-combobox'].blur()
      //

      this.$nextTick(() => {
        for (const [key, value] of Object.entries(this.stepData)) {
          if (['name', 'location'].includes(key)) continue
          if (typeof value === 'object') {
            this.formData[key] = `{${value.key}}`
          } else if (typeof value === 'string') {
            this.formData[key] = value
          }
        }
        this.formData.name = { ...this.stepData.name }
        this.formData.name[this.defaultLanguage] = this.convertToSTCString(this.jsonObj.name.content[0])

        this.formData.location = { ...this.stepData.location }
        this.formData.location[this.defaultLanguage] = this.convertToSTCString(this.jsonObj.location.content[0])

        this.formData.date = this.convertToSTCString(this.jsonObj.date.content[0])
        this.formData.lat = this.convertToSTCString(this.jsonObj.lat.content[0])
        this.formData.lng = this.convertToSTCString(this.jsonObj.lng.content[0])
        // this.formData.date = this.convertToSTCString(this.jsonObj.date.content[0])
        // this.formData.lat = this.convertToSTCString(this.jsonObj.lat.content[0])
        // this.formData.lng = this.convertToSTCString(this.jsonObj.lng.content[0])
        this.$store.dispatch('updateJourneyStepData', { data: this.formData, index: this.stepIndex })
        this.editModal = false
      })
    },

    close () {
      this.editModal = false
    }
  },
  data () {
    return {
      test: null,
      stepData: {},
      formData: {},
      editModal: false,
      jsonObj: {
        name: {},
        location: {},
        date: {},
        lat: {},
        lng: {}
      }
    }
  },

  created () {
    this.stepData = JSON.parse(JSON.stringify(this.getJourney[this.stepIndex]))

    this.stepData.name[this.defaultLanguage] = this.convertToMention(this.stepData.name[this.defaultLanguage])

    this.stepData.location[this.defaultLanguage] = this.convertToMention(this.stepData.location[this.defaultLanguage])
  }
}

</script>

<style lang="sass">

@import "@/variables.sass"

.journey-step
  background: $bg-grey
  border-radius: 6px
  .scm-field
    background: #dfdfdf
    color: black
    padding: 3px 3px
    border-radius: 6px
    font-family: monospace

</style>
